import { render } from "./AppTemplate.vue?vue&type=template&id=5853b39b&ts=true"
import script from "./AppTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./AppTemplate.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/templates/AppTemplate.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5853b39b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5853b39b', __exports__)) {
    api.reload('5853b39b', __exports__)
  }
  
  module.hot.accept("./AppTemplate.vue?vue&type=template&id=5853b39b&ts=true", () => {
    api.rerender('5853b39b', render)
  })

}


export default __exports__